import {useState, useEffect} from "react";
import {getAllDetails} from "../../services/liferay/PaymentReconcillation";
import "./helpers/style.css";
import {downloadExcel, downloadXML, dateFormatter} from "./helpers/fileFormatter";
import {Grid} from "./Grid";
import {Loader} from "../../common/Loader";
import {getPicklist} from "../../services/liferay/PaymentReconcillation";
import {otherServicesDashboardURL} from "../../utils/util";
import {fetchTranslationData} from "../../services/translation/translation";
import {ServiceTranslation} from "../../utils/constants";


const PaymentReconcilliation = () => {
    const [gridData, setGridData] = useState([]);
    const [showGrid, setShowGrid] = useState(false);
    const [error, setError] = useState(false);
    const [actionType, setActionType] = useState("");
    const [formData, setFormData] = useState({
        servCode: "",
        sptrn: "",
        degtrn: "",
        paymentMethod: "",
        status: "",
        fromDate: "",
        toDate: ""
    });
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [list, setList] = useState([]);
    const [translationMap, setTranslationMap] = useState(null);
    const RECORDS_PER_PAGE = 10;
    const today = new Date().toISOString().split("T")[0];


    useEffect(() => {
        getPicklist().then((result) => {

            let names = result?.data?.listTypeEntries.map((entry) => entry.name);
            setList(names);
        });
    }, []);

    useEffect(() => {
        fetchTranslationData(ServiceTranslation.PaymentReconciliation).then((result) => {
            setTranslationMap(result);
        });
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;

        let sanitizedValue = value;
        // applying validation for sptrn and degtrn values
        if ( name === "sptrn" || name === "degtrn") {
        sanitizedValue = value.replace(/[^A-Za-z0-9\u0600-\u06FF\s]/g, "");
        }
        setFormData((prevData) => ({
            ...prevData,
            [name]: sanitizedValue,
        }));
    };

    const fetchData = async (actionType, page = 1, isPaginating = false) => {
        try {
            const isExport = actionType === 'xml' || actionType === 'excel';
            const requestData = {
                ...formData,
                fromDate: formData.fromDate ? dateFormatter(formData.fromDate, false) : "",
                toDate: formData.toDate ? dateFormatter(formData.toDate, true) : ""
            };
            if (!isExport) {
                requestData.page = page;
                requestData.pageSize = RECORDS_PER_PAGE;
            }

            if (!isPaginating) {
                setLoading(true);
            }
            const response = await getAllDetails(requestData);
            const responseData = response?.data;
            const items = responseData?.items || [];

            if (items.length > 0) {
                setError(false);
                setLoading(false);
                if (isExport) {
                    if (actionType === 'xml') {
                        downloadXML(items, formData.servCode);
                    } else {
                        downloadExcel(items);
                    }
                } else {
                    setCurrentPage(page);
                    setGridData(items);
                    setTotalPages(responseData.totalPages || 1);
                    setShowGrid(true);
                }
            } else {
                setLoading(false);
                if (!isPaginating) {
                    setShowGrid(false);
                    setError(true);
                }
            }
            return response;
        } catch (err) {
            setShowGrid(false);
            setLoading(false);
            setError(true);
            console.error("Error fetching data:", err);
        }
    };

    const handlePageChange = (page) => {
        fetchData('grid', page, true);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const form = e.target;
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        fetchData(actionType, 1).catch(() => setError(true));
    };

    if (loading) {
        return (
            <Loader/>);

    }

    return (
        <>
            <div className="payment-reconcilliation-container">
                <div className="container">
                    <div className="reconciliationFormGroup">
                        <div className="title-bar">
                            <div
                                className="report-title">{translationMap?.reconciliation_report || "RECONCILLIATION REPORT"}
                            </div>
                            <button
                                className="dashboard-btn"
                                onClick={() => window.location.href = otherServicesDashboardURL()}>

                                {translationMap?.go_to_dashboard || "Go to Dashboard"}
                            </button>
                        </div>
                        <div className="reconciliationForm">
                            <form id="reconForm" onSubmit={handleSubmit}>
                                <div className="form-section">
                                    <div className="formGroup">
                                        <label>
                                            {translationMap?.service || "Service"}
                                        </label>
                                        <select name="servCode" value={formData.servCode} onChange={handleChange}
                                                required>
                                            <option value="">{translationMap?.select || "---Select---"}</option>
                                            <option
                                                value="SLA">{translationMap?.sick_leave_application || "Sick Leave Application"}</option>
                                            <option
                                                value="MR">{translationMap?.medical_report || "Medical Report"}</option>
                                            <option
                                                value="NPS">{translationMap?.renew_health_card || "Renew Health Card"}</option>
                                            <option
                                                value="PHC">{translationMap?.premarital_screening || "Pre-Marital Screening"}</option>
                                        </select>
                                    </div>

                                    <div className="formGroup">
                                        <label>{translationMap?.sptrn || "SPTRN"}</label>
                                        <input
                                            type="text"
                                            name="sptrn"
                                            value={formData.sptrn}
                                            onChange={handleChange}/>

                                    </div>

                                    <div className="formGroup">
                                        <label>{translationMap?.degtrn || "DEGTRN"}</label>
                                        <input
                                            type="text"
                                            name="degtrn"
                                            value={formData.degtrn}
                                            onChange={handleChange}/>

                                    </div>

                                    <div className="formGroup">
                                        <label>{translationMap?.payment_method || "Payment Method"}</label>
                                        <select
                                            name="paymentMethod"
                                            value={formData.paymentMethod}
                                            onChange={handleChange}>

                                            <option value="">{translationMap?.select || "---Select---"}</option>
                                            <option
                                                value="Credit Card">{translationMap?.credit_card || "Credit Card"}</option>
                                            <option
                                                value="Debit Card">{translationMap?.debit_card || "Debit Card"}</option>
                                            <option
                                                value="EdirhamG2">{translationMap?.edirham_g2 || "EdirhamG2"}</option>
                                            <option value="Wallet">{translationMap?.wallet || "Wallet"}</option>
                                        </select>
                                    </div>

                                    <div className="formGroup">
                                        <label>{translationMap?.status || "Status"}</label>
                                        <select
                                            name="status"
                                            value={formData.status}
                                            onChange={handleChange}>

                                            <option value="">{translationMap?.select || "---Select---"}</option>
                                            {list?.map((item, index) => {
                                                return (
                                                    <option key={index} value={item}>
                                                        {item}{" "}
                                                    </option>);

                                            })}
                                        </select>
                                    </div>

                                    <div className="formGroup">
                                        <label>
                                            {translationMap?.from || "From"}
                                        </label>
                                        <input
                                            type="date"
                                            name="fromDate"
                                            value={formData.fromDate}
                                            onChange={handleChange}
                                            required={!formData.sptrn && !formData.degtrn}
                                            max={today}/>

                                    </div>

                                    <div className="formGroup">
                                        <label>
                                            {translationMap?.to || "To"}
                                        </label>
                                        <input
                                            type="date"
                                            name="toDate"
                                            value={formData.toDate || ''}
                                            onChange={handleChange}
                                            required={!formData.sptrn && !formData.degtrn}
                                            max={today}
                                            min={formData?.fromDate}/>

                                    </div>
                                </div>
                                <div className="buttons">
                                    <button type="submit" name="action" value="grid"
                                            onClick={() => setActionType("grid")}>{translationMap?.grid_button || "Grid"}</button>
                                    <button type="submit" name="action" value="xml"
                                            onClick={() => setActionType("xml")}>{translationMap?.xml_button || "XML"}</button>
                                    <button type="submit" name="action" value="excel"
                                            onClick={() => setActionType("excel")}>{translationMap?.excel_button || "Excel"}</button>
                                </div>
                            </form>
                        </div>
                    </div>

                    {showGrid && gridData && gridData.length > 0 &&
                        <Grid currentRecords={gridData} currentPage={currentPage}
                              onPageChange={handlePageChange} totalPages={totalPages} translationMap={translationMap}/>
                    }

                    {error &&
                        <div className="noDetail">{translationMap?.no_details_found || "No Details found"}</div>
                    }
                </div>
            </div>
        </>);

};

export default PaymentReconcilliation;